import React from "react";
import { Link } from "react-router-dom";

/** @typedef {'general' | 'pondFish' | 'sampling' | 'gallery' | 'table' | 'graph' | 'notes'} WorkflowSection */

const SECTION_META = {
  general: { title: "Overview", icon: "fa-cog" },
  pondFish: { title: "Fish Sampled/Caught", icon: "fa-fish" },
  sampling: { title: "Sampling Detail", icon: "fa-chart-line" },
  gallery: { title: "Gallery", icon: "fa-images" },
  table: { title: "Table view", icon: "fa-table" },
  graph: { title: "Graph view", icon: "fa-chart-area" },
  notes: { title: "Notes", icon: "fa-note-sticky" },
};

/**
 * Top header: breadcrumbs + primary title (matches active workflow tab) + subtitle.
 */
export default function PondDetailWorkflowPageHeader({
  pondDetailId,
  section = "general",
  detailName,
  className = "",
  noBottomMargin = false,
}) {
  const sid =
    pondDetailId != null && pondDetailId !== "" ? String(pondDetailId) : "";
  if (!sid) return null;

  const meta = SECTION_META[section] || SECTION_META.general;

  const namePart =
    detailName && String(detailName).trim()
      ? ` (${String(detailName).trim()})`
      : "";

  const subtitle = `Update Fishing / Sampling Data${namePart}`;

  return (
    <div className={`${noBottomMargin ? "mb-0" : "mb-4"} ${className}`.trim()}>
      <ul className="breadcrumb mb-2">
        <li className="breadcrumb-item">
          <Link to="/dashboard">Home</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/fishingData">Fishing Data</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to={`/pondDetailOverview/${sid}`}>Update Fishing / Sampling Data</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          {meta.title}
        </li>
      </ul>
      <h1 className="mb-0 page-header d-flex align-items-center gap-3 flex-wrap">
        <span className="donezo-page-header-icon" aria-hidden>
          <i className={`fas ${meta.icon}`} aria-hidden />
        </span>
        <span className="d-flex flex-column" style={{ minWidth: 0 }}>
          <span className="donezo-page-header-title">{meta.title}</span>
          <span className="donezo-page-header-subtitle">{subtitle}</span>
        </span>
      </h1>
    </div>
  );
}
